import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/20/solid';

function SuccessMessage({ message, linkText, linkHref }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(true);
  }, [message]);

  if (!isVisible) return null;

  return (
    <div className="border-l-4 border-green-400 bg-green-50 p-4 m-2 relative">
      <div className="flex justify-between">
        <div className="flex">
          <div className="flex-shrink-0">
            <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm text-green-700">
              {message}{' '}
              {linkText && linkHref && (
                <a href={linkHref} className="font-medium text-green-700 underline hover:text-green-600">
                  {linkText}
                </a>
              )}
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <XMarkIcon
            className="h-5 w-5 text-green-700 cursor-pointer"
            aria-hidden="true"
            onClick={() => setIsVisible(false)}
          />
        </div>
      </div>
    </div>
  );
}

SuccessMessage.propTypes = {
  message: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  linkHref: PropTypes.string,
};

export default SuccessMessage;
